import React from 'react';
import Classnames from 'classnames';

export default class SignpostItem extends React.Component {

    constructor(props) {
        super(props);

        this.hashChanged = this.hashChanged.bind(this);
        this.state = {
            highlight: window.location.hash === '#' + props.id
        };
    }

    hashChanged() {
        setTimeout(()=> this.setState({highlight: window.location.hash === '#' + this.props.id}));
    }

    componentDidMount() {
        window.addEventListener("hashchange", this.hashChanged);
    }

    componentWillUnmount() {
        window.removeEventListener("hashchange", this.hashChanged);
    }
    render() {
        let classes = Classnames({ highlight: this.state.highlight });
        return (
            <li id={this.props.id} className={classes}>
                <a href={this.props.url} target="_blank" rel="noopener noreferrer">{this.props.title}</a>
            </li>
        );
    }
}
